$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "organizer_booking_area_table" && a === "list") {
    $("select[name=booking_table_id]").select2({
      theme: "bootstrap4",
    });

    $(document).on("click", "#booking-area-table-register-button", function () {
      let bookingAreaId = $(this).attr("data-booking-area-id");
      let tableId = $("select[name='booking_table_id'] option:selected").val();
      let locationId = $("body").attr("event_id");

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_booking_area_table/new",
        data: {
          booking_area_id: bookingAreaId,
          table_id: tableId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("select[name='booking_table_id'] option:selected").remove();
            $("#booking-area-table-list-wrapper").empty();
            $("#booking-area-table-list-wrapper").append(data.html);

            let bookingAreaTableList = document.getElementById(
              "booking-area-table-list-sortable",
            );
            Sortable.create(bookingAreaTableList, {
              handle: ".booking-area-table-reorder",
              animation: 150,
              sort: true,
              delay: 0,
              touchStartThreshold: 0,
              disabled: false,
              draggable: ".booking-area-table",
              direction: "horizontal",
              ghostClass: "sortable-ghost",
              dataIdAttr: "data-booking-area-table-id",
              removeCloneOnHide: true,
              store: {
                set: function (bookingAreaTableList) {
                  let listOrder = bookingAreaTableList.toArray();
                  ajaxListOrder(listOrder);
                },
              },
            });

            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    function ajaxListOrder(listOrder) {
      let bookingArea = $("body").attr("booking_area_id");

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_booking_area_table/list_sort",
        data: {
          list_order: JSON.stringify(listOrder),
          booking_area_id: bookingArea,
        },
      })
        .done(function (data) {
          if (data === true) {
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
